function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.29371 0.657135L7.22828 3.71585C7.54273 4.04337 7.32008 4.60342 6.87574 4.60342H1.00758C0.563242 4.60342 0.340586 4.04337 0.655039 3.71585L3.58863 0.657135C3.78395 0.454132 4.09938 0.454132 4.29371 0.657135Z",
  fill: "#707070"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.58863 10.8526L0.655039 7.79398C0.340586 7.46646 0.563242 6.9064 1.00758 6.9064H6.87574C7.32008 6.9064 7.54273 7.46646 7.22828 7.79398L4.29371 10.8526C4.09938 11.0557 3.78395 11.0557 3.58863 10.8526Z",
  fill: "#707070"
});

var SvgCaretDouble = function SvgCaretDouble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCaretDouble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caretDouble.2abf03eb.svg";
export { ForwardRef as ReactComponent };